import { CurrencyPipe, DatePipe } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { MessageModule } from 'primeng/message';
import { SkeletonModule } from 'primeng/skeleton';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';

import { OrdersService } from '@core/services/orders';

@Component({
  selector: 'yt-order-details',
  imports: [
    CurrencyPipe,
    DatePipe,
    RouterModule,
    ButtonModule,
    CardModule,
    MessageModule,
    SkeletonModule,
    TableModule,
    TagModule
  ],
  templateUrl: './order-details.html',
  styleUrl: './order-details.scss'
})
export class OrderDetails {
  private readonly ordersService = inject(OrdersService);

  readonly id = input.required<string>();

  protected readonly order = computed(() => this.ordersService.ordersById()[this.id()] ?? null);

  protected readonly isLoading = computed(() => Object.keys(this.ordersService.ordersById()).length === 0);
}
